import React from 'react';
import { Col, ControlLabel, FormGroup, Row } from 'react-bootstrap';
import { Field, FormSection } from 'redux-form';
import { addValidator, required } from 'redux-form-validators';
import { DatePickerDob2, InfoButton } from '../../../../../../../../common/components';
import { SimpleHorizontalFormControl } from '../../../../../../../../common/simpleComponents';
import { SelectField } from '../../../../../../../../common/components/ReduxFormField';
import InputError from '../../../../../InputError/InputError';
import AutoCapsInput from '../../../../../../../../common/components/AutoCapsInput/AutoCapsInput';
import Address from '../../../Address/Address';
import capitalise from '../../../../../../../../helpers/capitialise';
import Declines from '../../../Declines/Declines';
import { isBefore, isSameDay, parse, startOfDay, subYears } from 'date-fns';
import { ADULT_TITLE_OPTIONS } from '../../../../../../../../helpers/titleOptions';

const MIN_AGE = 18;
const nameValidator = addValidator({
  defaultMessage: 'Name is required',
  validator(options, value, allValues) {
    const traveller = allValues.data.attributes.metadata.travellers[0];
    const { title, first_name, last_name } = traveller;

    if (!title || !first_name || !last_name) {
      return {
        id: 'data.attributes.metadata.travellers.0',
        defaultMessage: 'Name is required',
      };
    }
  },
});

const addressValidator = addValidator({
  defaultMessage: 'Address is required',
  validator: function(options, value) {
    const line1 = value.line1;
    const town = value.town;
    if (!line1 || !town) {
      return {
        id: 'data.attributes.metadata.travellers.0.address',
        defaultMessage: 'Address is required',
      };
    }
  },
});

const dobValidator = addValidator({
  defaultMessage: 'Dob is required',
  validator: function(options, value) {
    const dob = parse(value, 'd/M/y', new Date());
    const minDob = startOfDay(subYears(new Date(), MIN_AGE));

    const isAdult = isBefore(dob, minDob) || isSameDay(minDob, dob);
    if (!isAdult) {
      return {
        id: 'data.attributes.metadata.travellers.0.dob',
        defaultMessage: 'Valid date is required',
      };
    }
  },
});

const LABEL_SIZE = 2;
const FIELD_SIZE = 6;

const NamesFields = ({ meta }) => {
  return (
    <>
      <FormGroup>
        <Col sm={LABEL_SIZE}>
          <ControlLabel>Name</ControlLabel>
        </Col>
        <Col sm={2}>
          <Field
            name={'title'}
            placeholder="Title"
            options={ADULT_TITLE_OPTIONS}
            component={SelectField}
          />
        </Col>
        <Col sm={3}>
          <Field
            name={'first_name'}
            placeholder="First Name"
            normalize={capitalise}
            component={AutoCapsInput}
          />
        </Col>
        <Col sm={3}>
          <Field
            name={'last_name'}
            placeholder="Surname"
            normalize={capitalise}
            component={AutoCapsInput}
          />
        </Col>
      </FormGroup>

      <FormGroup>
        <Col smOffset={LABEL_SIZE}>
          <InputError meta={meta} />
        </Col>
      </FormGroup>
    </>
  );
};

const ComponentContainer = ({ label, children }) => (
  <FormGroup>
    <Col sm={LABEL_SIZE}>
      <ControlLabel>{label}</ControlLabel>
    </Col>
    <Col sm={FIELD_SIZE}>{children}</Col>
  </FormGroup>
);

const ReviewTab = ({ definitions, allErrors }) => {
  return (
    <div className={'sl-quote-tab'}>
      <Declines show={!!allErrors.length} errors={allErrors} />
      <Row>
        <Col sm={12}>
          <div className={'sl-review-tab--text'}>
            We will take the policyholder’s details now, then when you register you can
            add any additional details &nbsp;{' '}
            <InfoButton red content={definitions.traveller_info} />
          </div>
        </Col>
      </Row>
      <FormSection name={'data.attributes.metadata.travellers.0'}>
        <Field
          component={NamesFields}
          name={'first_name'}
          validate={nameValidator({ msg: 'Name is required' })}
        />
        <ComponentContainer label={'Mobile number'}>
          <Field
            name={'phone1'}
            placeholder="Optional"
            component={SimpleHorizontalFormControl}
          />
        </ComponentContainer>
        <ComponentContainer label={'Contact Email Address'}>
          <Field
            name={'email'}
            type="email"
            placeholder={'Enter email address'}
            component={SimpleHorizontalFormControl}
            validate={required({ msg: 'Email is required' })}
          />
        </ComponentContainer>

        <Field
          name={'dob'}
          label="Date of birth"
          messageType={'Alert'}
          component={DatePickerDob2}
          labelSize={LABEL_SIZE}
          validate={dobValidator({})}
        />
        <Field
          name={'address'}
          labelSize={LABEL_SIZE}
          component={Address}
          validate={addressValidator({})}
        />
      </FormSection>
    </div>
  );
};

export default ReviewTab;
